//
import { Cliente } from '../../shared/entity/Cliente';
import { celularMask, validarEmail } from '../../shared/helper';
import React, { useState } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import clienteApi from '../../apis/clienteApi';
import colors from '../../colors';
import { SIDE_PADDING, TOP_PADDING } from '../../constants';
import AlertDialog from '../Generic/AlertDialog';
import Button from '../Generic/Button';
import CTextInput from '../Generic/CTextInput';
import Title from '../Generic/Title';

import GoogleLogin from '../Generic/GoogleLogin';

type Props = {
  onCadastro: (novoCli: Cliente, senha: string) => void;
  preCadastro?: boolean;
};

const FormCadastro: React.FC<Props> = (props) => {
  const { onCadastro, preCadastro } = props;

  const [cliente, setCliente] = useState(new Cliente());
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [alert, setAlert] = useState({ titulo: '', mensagem: '', show: false });

  const mostrarAlert = (titulo: string, mensagem: string) => {
    setAlert({ titulo, mensagem, show: true });
  };

  const validar = () => {
    if (cliente.nome === '') {
      mostrarAlert('Erro', 'Preencha o campo nome');
      return false;
    }
    if (cliente.email !== '') {
      if (!validarEmail(cliente.email)) {
        mostrarAlert('Erro', 'Insira um email válido.');
        return false;
      }
    }
    if (cliente.celular === '') {
      mostrarAlert('Erro', 'Preencha o campo celular');
      return false;
    }
    if (cliente.celular.length < 15) {
      mostrarAlert('Erro', 'Informe o número do celular no seguinte formato: (99) 99999-9999');
      return false;
    }
    if (!preCadastro && cliente.senha === '') {
      mostrarAlert('Erro', 'Preencha o campo senha');
      return false;
    }
    if (cliente.senha !== confirmarSenha) {
      mostrarAlert('Erro', 'Senha e confirmação de senha devem ser iguais.');
      return false;
    }
    return true;
  };

  const cadastrar = async () => {
    try {
      if (validar()) {
        const novoCli = await clienteApi.insert(cliente);
        onCadastro(novoCli, confirmarSenha);
      }
    } catch (err) {
      console.log('err', err);
      mostrarAlert('Erro.', `Ocorreu um erro ao finalizar o cadastro: ${err.data || err.message}`);
    }
  };

  return (
    <View style={styles.form}>
      <AlertDialog
        titulo={alert.titulo}
        descricao={alert.mensagem}
        show={alert.show}
        onClose={() => setAlert({ titulo: '', mensagem: '', show: false })}
        // actions={alert.actions}
      />

      <Title>Ainda não é cliente?</Title>
      <Title style={{ marginBottom: 10 }}>Cadastre-se!</Title>

      {!preCadastro && (
        <>
          <GoogleLogin />
          <Text style={{ color: colors.darkGrey, margin: 20 }}>OU</Text>
        </>
      )}

      <CTextInput
        label={'Nome completo'}
        onChangeText={(txt) => {
          const novoCliente = { ...cliente };
          novoCliente.nome = txt;
          setCliente(novoCliente);
        }}
        value={cliente.nome}
        style={styles.input}
      />

      <CTextInput
        label={'Email (opcional)'}
        onChangeText={(txt) => {
          const novoCliente = { ...cliente };
          txt = txt.replace(/\s/g, '');
          novoCliente.email = txt;
          setCliente(novoCliente);
        }}
        autoCapitalize="none"
        value={cliente.email}
        style={styles.input}
      />

      <CTextInput
        label={'Celular'}
        maxLength={16}
        placeholder={'(99) 9 9999-9999'}
        onChangeText={(txt) => {
          const novoCliente = { ...cliente };
          novoCliente.celular = celularMask(txt);
          setCliente(novoCliente);
        }}
        value={cliente.celular}
        style={styles.input}
      />

      {!preCadastro && (
        <>
          <CTextInput
            label={'Senha'}
            secureTextEntry={true}
            onChangeText={(txt) => {
              const novoCliente = { ...cliente };
              novoCliente.senha = txt;
              setCliente(novoCliente);
            }}
            value={cliente.senha}
            style={styles.input}
          />

          <CTextInput
            label={'Confirme sua senha'}
            secureTextEntry={true}
            onChangeText={(txt) => setConfirmarSenha(txt)}
            value={confirmarSenha}
            style={styles.input}
          />
        </>
      )}

      <Button title="Cadastrar" onPress={() => cadastrar()} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff'
  },
  content: {
    paddingTop: TOP_PADDING,
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  },
  form: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export default FormCadastro;
